import { useTheme } from '@emotion/react';

const useJsonEditorTheme = () => {
  const ruiTheme = useTheme();

  const darkTheme = {
    displayName: 'dark',
    fragments: { edit: ruiTheme.palette.positive.main },
    styles: {
      container: {
        backgroundColor: ruiTheme.palette.surface.default,
        fontFamily: ruiTheme.typography.fontFamilyBody,
      },
      collection: {},
      collectionInner: {},
      collectionElement: {},
      dropZone: {},
      property: ruiTheme.palette.text.body,
      bracket: {
        color: ruiTheme.palette.primary.main,
        fontWeight: ruiTheme.typography.fontWeight.semiBold,
      },
      itemCount: { color: ruiTheme.palette.text.secondary, fontStyle: 'italic' },
      string: ruiTheme.palette.primary.main,
      number: ruiTheme.palette.negative.active,
      boolean: ruiTheme.palette.positive.main,
      null: {
        color: ruiTheme.palette.negative.main,
        fontVariant: 'small-caps',
        fontWeight: ruiTheme.typography.fontWeight.semiBold,
      },
      input: [ruiTheme.palette.text.body, { fontSize: '90%', backgroundColor: ruiTheme.palette.surface.default }],
      inputHighlight: ruiTheme.palette.purple[500],
      error: {
        fontSize: '0.8em',
        color: ruiTheme.palette.negative.main,
        fontWeight: ruiTheme.typography.fontWeight.semiBold,
      },
      iconCollection: ruiTheme.palette.primary.main,
      iconEdit: ruiTheme.palette.positive.main,
      iconDelete: ruiTheme.palette.negative.main,
      iconAdd: ruiTheme.palette.primary.hover,
      iconCopy: ruiTheme.palette.primary.main,
      iconOk: ruiTheme.palette.positive.main,
      iconCancel: ruiTheme.palette.negative.main,
    },
  };

  const lightTheme = {
    displayName: 'light',
    fragments: { edit: ruiTheme.palette.positive.main },
    styles: {
      container: {
        backgroundColor: ruiTheme.palette.surface.default,
        fontFamily: ruiTheme.typography.fontFamilyBody,
      },
      collection: {},
      collectionInner: {},
      collectionElement: {},
      dropZone: {},
      property: ruiTheme.palette.text.body,
      bracket: {
        color: ruiTheme.palette.primary.main,
        fontWeight: ruiTheme.typography.fontWeight.semiBold,
      },
      itemCount: { color: ruiTheme.palette.text.secondary, fontStyle: 'italic' },
      string: ruiTheme.palette.primary.main,
      number: ruiTheme.palette.negative.active,
      boolean: ruiTheme.palette.positive.main,
      null: {
        color: ruiTheme.palette.negative.main,
        fontVariant: 'small-caps',
        fontWeight: ruiTheme.typography.fontWeight.semiBold,
      },
      input: [ruiTheme.palette.text.body, { fontSize: '90%', backgroundColor: ruiTheme.palette.surface.default }],
      inputHighlight: ruiTheme.palette.purple[500],
      error: {
        fontSize: '0.8em',
        color: ruiTheme.palette.negative.main,
        fontWeight: ruiTheme.typography.fontWeight.semiBold,
      },
      iconCollection: ruiTheme.palette.primary.main,
      iconEdit: ruiTheme.palette.positive.main,
      iconDelete: ruiTheme.palette.negative.main,
      iconAdd: ruiTheme.palette.primary.hover,
      iconCopy: ruiTheme.palette.primary.main,
      iconOk: ruiTheme.palette.positive.main,
      iconCancel: ruiTheme.palette.negative.main,
    },
  };

  return ruiTheme.palette.activeMode === 'dark' ? darkTheme : lightTheme;
};

export default useJsonEditorTheme;
